import { z } from "zod";

/**
 * Mileage rate change (Business Logic §8): Admin submits (Mondays; fast-track
 * any day on a ≥₱10/L spike), Executive approval required, live next
 * operating day. The Edge Function recomputes bracket/fast-track/suggested
 * rate server-side (submit_mileage_rate_request, migration 0022) — this
 * schema only validates the human inputs.
 */
export const submitMileageRequestSchema = z.object({
  fuelPrice: z.number().positive().max(1000),
  requestedEffectiveDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "YYYY-MM-DD"),
  notes: z.string().max(500).optional(),
});

export type SubmitMileageRequestInput = z.infer<typeof submitMileageRequestSchema>;

export const approveMileageRequestSchema = z.object({
  approve: z.boolean(),
  reason: z.string().max(500).optional(),
});

export type ApproveMileageRequestInput = z.infer<typeof approveMileageRequestSchema>;
